module.exports = __webpack_public_path__ + "img/88185e5.png";